import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { basicApiAsyncThunkCreator } from '../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../rootReducer';
import { showErrorMessage, showSuccessMessage } from '../notifications';
import { HttpMethods, SERVICES } from '../../services/api';
import { Features, isFeatureEnabled } from '../../featureToggles/features';

export interface IResponseForInvoiceCreation {
  message?: string;
}

export interface IDealInvoicePayload {
  hubspotDealId: string;
  projectName?: string;
  purchaseOrderNumber?: string;
  customerId?: string;
  // use in Features.BillingUserFacing
  carbonCopyRecipients?: string[];
  // end of use in Features.BillingUserFacing

  // Remove this prop below when Features.BillingUserFacing is passed to staging and pro
  campaignName?: string;
  amount?: number;
}

export const sendInvoiceForDeal: AsyncThunk<IResponseForInvoiceCreation | void, IDealInvoicePayload, ThunkAPI> = createAsyncThunk(
  'accounts/deals/sendInvoice',
  async (data: IDealInvoicePayload, thunk) => {
    try {
      const customerId = data.customerId;
      const amount = data.amount;
      delete data.customerId;
      delete data.amount;
      if (!isFeatureEnabled(Features.BillingUserFacing)) {
        delete data.carbonCopyRecipients;
      }

      const response = await basicApiAsyncThunkCreator<IResponseForInvoiceCreation | void, IDealInvoicePayload>({
        endpoint: `/customer/${customerId}/invoice-deal`,
        microservice: SERVICES.USERS_SERVICE,
        authenticated: true,
        method: HttpMethods.Post,
        contentType: 'application/json'
      })(data, thunk);
      const message = isFeatureEnabled(Features.DealZero) && amount === 0
        ? 'The process was successfully completed!'
        : 'Invoice has been sent!';

      thunk.dispatch(showSuccessMessage(message));

      return response;
    } catch (err) {
      thunk.dispatch(showErrorMessage(JSON.stringify(err) || 'An error occurred while sending the invoice'));
      return thunk.rejectWithValue(err);
    }
  }
);
